import { Injectable, inject } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { InventoryDocumentKind } from '@skylab-shared/dataModel';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface InventoryStocktakingDocumentLink {
    documentNumber: string;
    kind: InventoryDocumentKind.InternalGoodsIssue | InventoryDocumentKind.InternalGoodsReceipt;
    id: number;
}

export class InventoryStocktakingDocumentLinksQuery extends Query<InventoryStocktakingDocumentLink[]> {
    public constructor(public readonly documentId: number) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(InventoryStocktakingDocumentLinksQuery)
export class InventoryStocktakingDocumentLinksQueryHandler implements QueryHandler<InventoryStocktakingDocumentLinksQuery> {
    #url = TaggedUrl.join('inventory/stocktaking/:id/links', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(query: InventoryStocktakingDocumentLinksQuery): Promise<InventoryStocktakingDocumentLink[]> {
        const url = fillPlaceholders(this.#url, { id: query.documentId });
        const { data } = await this.#http.get<InventoryStocktakingDocumentLink[]>(url);
        return data;
    }
}
